import React, { Component } from 'react';

class Testimonials extends Component {
  render() {
    return (
      <section id="testimonials">
        <div className="text-container">
           <div className="row">

              <div className="two columns header-col">
                 <h1><span>Client Testimonials</span></h1>
              </div>

              <div className="ten columns flex-container">
                    <ul className="slides">
                      <li>
                        <blockquote>
                          <p>
                            Yusuf has broad web development knowledge. He open to new technologies and always eager to learn something new. He able to work under pressure by be able to manage multiple projects and multiple roles. As a team, work with him is a pleasure. He will try to understand your technical issues and suggest solutions with no hesitations.
                          </p>
                          <cite>Fariz Sofyan</cite>
                        </blockquote>
                      </li>
                      <li>
                        <blockquote>
                          <p>
                            Yusuf is what you may call a jack of all trades. His status as a recent graduate will fool everyone into thinking that he is inexperienced, as it is surely the opposite. His youth is merely a sign that he is filled to the brim with vigor and a thirst to autonomously self-improve.
                            I've been working closely with Yusuf on highly demanding projects which required us to utilize a plethora of tools and technologies (from native PHP to the more recent frameworks), and he had shown a capability to tackle each assignment with flying colors.
                            As a team player, Yusuf is also highly commendable as he is able to multi-task between various key roles seamlessly, whether as a system analyst, developer, webmaster, QA, and even as a team leader (even to manage our office's network!)
                          </p>
                          <cite>Sukmaji Hanindyo Kumoro</cite>
                        </blockquote>
                      </li>
                    </ul>
                 </div>
              </div>
           </div>
      </section>
    );
  }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/Components/Testimonials.js